import type { ReactNode } from "react";
import "./Field.css";

export interface FieldProps {
  /** id of the control inside, so the label points to it */
  htmlFor?: string;
  label?: ReactNode;
  /** small grey text under the control */
  hint?: ReactNode;
  /** red text under the control; also turns the border red */
  error?: ReactNode;
  className?: string;
  children: ReactNode;
}

/**
 * Label above, control, then hint or error below.
 * TextField, TextArea and Select use it; wrap any custom control
 * (phone input, date picker) in it to get the same look.
 */
const Field = ({
  htmlFor,
  label,
  hint,
  error,
  className = "",
  children,
}: FieldProps) => (
  <div
    className={`ds-field ${error ? "has-error" : ""} ${
      hint ? "has-hint" : ""
    } ${className}`.trim()}
  >
    {label && (
      <label className="ds-field__label" htmlFor={htmlFor}>
        {label}
      </label>
    )}
    {children}
    {error && typeof error !== "boolean" ? (
      <p className="ds-field__error" role="alert">
        {error}
      </p>
    ) : (
      hint && <p className="ds-field__hint">{hint}</p>
    )}
  </div>
);

export default Field;
